export default function IconPrint({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0.53 0.53 16.95 16.95"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M4.25492 12.6892H2.14617C1.86653 12.6892 1.59835 12.5781 1.40062 12.3804C1.20288 12.1827 1.0918 11.9145 1.0918 11.6348V6.36297C1.0918 6.08333 1.20288 5.81515 1.40062 5.61741C1.59835 5.41968 1.86653 5.30859 2.14617 5.30859H15.853C16.1327 5.30859 16.4009 5.41968 16.5986 5.61741C16.7963 5.81515 16.9074 6.08333 16.9074 6.36297V11.6348C16.9074 11.9145 16.7963 12.1827 16.5986 12.3804C16.4009 12.5781 16.1327 12.6892 15.853 12.6892H13.7443"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.20117 7.41797H4.25555"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.25488 9.52637H13.7443V16.907H4.25488V9.52637Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.7443 5.3093H4.25488V2.14617C4.25488 1.86653 4.36597 1.59835 4.5637 1.40062C4.76144 1.20288 5.02962 1.0918 5.30926 1.0918H12.6899C12.9695 1.0918 13.2377 1.20288 13.4354 1.40062C13.6332 1.59835 13.7443 1.86653 13.7443 2.14617V5.3093Z"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.36426 11.6348H11.6361"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.36426 13.7441H10.0546"
        stroke="currentColor"
        strokeWidth="1.13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
